import type { AppContextEntry } from '../../chat-app-context'
import { describeEntity, useChatAppContext } from '../../chat-app-context'
import type { ConfigureType } from './ConfigurePage'

export interface AgentConfigAppContextInput {
  agentType: ConfigureType
  /** `?id=` — absent while the list is showing. */
  configId?: string
  /** Config display name, once the row has loaded. */
  configName?: string
  configState?: string
}

export function buildAgentConfigAppContextEntries(
  input: AgentConfigAppContextInput
): AppContextEntry[] {
  const entries: AppContextEntry[] = [{ key: 'Agent type', value: input.agentType }]
  if (input.configId !== undefined && input.configId !== '') {
    entries.push({
      key: 'Config',
      value: describeEntity({
        name: input.configName,
        fields: [['state', input.configState]],
        id: input.configId
      })
    })
  }
  return entries
}

/** Baseline search params the entries above stand in for. */
export const CONFIGURE_SUPERSEDED_PARAMS = ['type', 'id']

/**
 * Registration shared by the four per-agent config detail views. The list
 * view registers from `ConfigurePage` itself, which has no loaded row to
 * enrich.
 */
export function useAgentConfigAppContext(input: AgentConfigAppContextInput): void {
  useChatAppContext(buildAgentConfigAppContextEntries(input), CONFIGURE_SUPERSEDED_PARAMS)
}
